import { render, staticRenderFns } from "./componentsLog.vue?vue&type=template&id=0c992399&scoped=true"
import script from "./componentsLog.vue?vue&type=script&lang=js"
export * from "./componentsLog.vue?vue&type=script&lang=js"
import style0 from "./componentsLog.vue?vue&type=style&index=0&id=0c992399&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c992399",
  null
  
)

export default component.exports